export const getTheme = async () => {
  return { data: {} };
  // return await axiosInstance.get(`launches`, { handlerEnabled });
};
